import { render, staticRenderFns } from "./SafetyHistoryCreate.vue?vue&type=template&id=0f800e82&scoped=true&"
import script from "./SafetyHistoryCreate.vue?vue&type=script&lang=js&"
export * from "./SafetyHistoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f800e82",
  null
  
)

export default component.exports